<mat-dialog-content class="flex h-full flex-col items-center justify-center">
	<div class="mb-4 flex select-none flex-row items-center justify-center text-4xl">
		<mat-icon inline>report_problem</mat-icon>
	</div>
	<span
		class="text-center"
		translate
		>workspace.id_mismatch_notice</span
	>
	<button
		(click)="reload()"
		class="!mt-3"
		color="primary"
		mat-button
	>
		{{ 'utils.reload' | translate }}
	</button>
</mat-dialog-content>
